import { lazy, ReactElement, Suspense } from "react";
import { Route, RouteProps, Routes, useLocation } from "react-router-dom";
import Navigation from "..//layout/navigation/Navigation";
import Home from "../pages/home/Home";
import Footer from "../layout/footer/Footer";
import LazyWrapper from "../components/LazyWrapper";
import Placeholder from "../components/pagePlaceholder/Placeholder";
import NotFound from "../pages/notFound/NotFound";

// Routers
const AdministrationRouter = lazy(() =>import(/* webpackChunkName: "administration" */ "../administration/Router"));
const LegalRouter = lazy(() =>import(/* webpackChunkName: "legal" */ "../legal/Router"));

// Components
const Awards = lazy(() => import(/* webpackChunkName: "ourstory-module" */ "../pages/portfolio/awards/Awards"));
const Blogs = lazy(() => import(/* webpackChunkName: "blog-module" */ "../pages/blog/Blogs"));
const Blog = lazy(() => import(/* webpackChunkName: "blog-module" */ "../pages/blog/Blog"));
const CaseStudies = lazy(() => import(/* webpackChunkName: "case-study-module" */ "../pages/portfolio/caseStudies/CaseStudies"));
const CaseStudy = lazy(() => import(/* webpackChunkName: "case-study-module" */ "../pages/portfolio/caseStudies/CaseStudy"));
const ContactUs = lazy(() => import(/* webpackChunkName: "contact-module" */ "../pages/contact/ContactPage"));
const OurStory = lazy(() => import(/* webpackChunkName: "ourstory-module" */ "../pages/about/story/OurStory"));
const Page = lazy(() => import(/* webpackChunkName: "page-module" */ "../pages/service/page/Page"));
const Partners = lazy(() => import(/* webpackChunkName: "ourstory-module" */ "../pages/about/partners/Partners"));
const Sustainability = lazy(() => import(/* webpackChunkName: "sustainability-module" */ "../pages/about/sustainability/Sustainability"));
const Testimonials = lazy(() => import(/* webpackChunkName: "ourstory-module" */ "../pages/portfolio/testimonials/Testimonials"));

function getLazyRoute(props: RouteProps & { element: ReactElement }) {
    return <Route {...props} element={<LazyWrapper component={props.element} />} />;
}

const Router = () => {
    const location = useLocation();
    const isAdminRoute = location.pathname.startsWith('/administration');

    return (
        <div className="app-container">
            {!isAdminRoute && <Navigation />}
            <main>
                <Suspense fallback={<Placeholder />}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        {getLazyRoute({ path: "/:area/:slug", element: <Page /> })}
                        {getLazyRoute({ path: "/blog", element: <Blogs /> })}
                        {getLazyRoute({ path: "/blogs", element: <Blogs /> })}
                        {getLazyRoute({ path: "/blog/:slug", element: <Blog /> })}
                        {getLazyRoute({ path: "/casestudies", element: <CaseStudies /> })}
                        {getLazyRoute({ path: "/casestudy/:slug", element: <CaseStudy /> })}
                        {getLazyRoute({ path: "/contact", element: <ContactUs /> })}
                        {getLazyRoute({ path: "/awards", element: <Awards /> })}
                        {getLazyRoute({ path: "/partners", element: <Partners /> })}
                        {getLazyRoute({ path: "/ourstory", element: <OurStory /> })}
                        {getLazyRoute({ path: "/testimonials", element: <Testimonials /> })}
                        {getLazyRoute({ path: "/sustainability", element: <Sustainability /> })}
                        {getLazyRoute({ path: "/legal/*", element: <LegalRouter /> })}
                        {getLazyRoute({ path: "/administration/*", element: <AdministrationRouter /> })}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Suspense>
            </main>
            {!isAdminRoute && <Footer />}
        </div>
    );
};

export default Router;